import { IoMdClose } from 'react-icons/io';
import { AUTH_URL } from '../../../features/apis/baseFectch';
import ReactToastify from '../../../customHook/useReactToastify';
import axios from 'axios';
import { GrResume } from 'react-icons/gr';
type CandidateDetailsProps = {
  open: boolean;
  onClose: () => void;
  candidate: any;
};
export const formatResumeDate = (date: string) => {
  const now = Date.now();
  const uploaded = new Date(date).getTime();

  const diffMs = now - uploaded;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(hours / 24);
  if (hours < 24) {
    return `Updated ${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }

  return `Updated ${days} day${days !== 1 ? 's' : ''} ago`;
};
export const download_url = `${AUTH_URL}/download`;
export const getDownloadParams = (url: string) => {
  const parts = url.split('/');
  const file = parts.pop() || '';

  const fileName = file.split('-').slice(1).join('-'); // remove timestamp
  const fileType = file.split('.').pop();

  const docKey = `resumes/${file}`;

  return { docKey, fileName, fileType };
};
const downloadFile = async (url: string) => {
  try {
    const { docKey, fileName } = getDownloadParams(url);
    const res = await axios.get(`${download_url}`, {
      params: { id: docKey, filename: fileName },
      responseType: 'blob',
      withCredentials: true,
    });

    const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.log('download error:', err);
    ReactToastify({ success: false, message: 'Failed to download file' });
  }
};

export function Avatar({ name }: { name: string }) {
  const initials = name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const colors = [
    'bg-red-400',
    'bg-blue-400',
    'bg-green-400',
    'bg-purple-400',
    'bg-pink-400',
    'bg-indigo-400',
    'bg-orange-400',
    'bg-teal-400',
  ];

  const index =
    name?.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    colors.length;

  const bgColor = colors[index];

  return (
    <div
      className={`w-20 h-20 rounded-full flex items-center justify-center text-white text-2xl font-semibold ${bgColor} shadow-lg mx-auto mb-4`}
    >
      {initials}
    </div>
  );
}

export default function CandidateDetails({
  open,
  onClose,
  candidate,
}: CandidateDetailsProps) {
  if (!open) return null;
  const details = [
    {
      label: 'Country',
      value: candidate?.location?.split(',')?.[1]?.trim() || 'N/A',
    },
    {
      label: 'State',
      value: candidate?.location?.split(',')?.[0]?.trim() || 'N/A',
    },
    {
      label: 'City',
      value: candidate?.location?.split(',')?.[0]?.trim() || 'N/A',
    },
    {
      label: 'Highest Qualification',
      value: candidate?.highestEducationLevel || 'N/A',
      highlight: true,
    },
    { label: 'Experience', value: `${candidate?.experienceYears || 0} Years` },
    { label: 'Primary Role', value: candidate?.primaryJob?.name || 'N/A' },
    { label: 'Match Score', value: `${candidate?.primaryJob?.match || 0}%` },
    { label: 'Status', value: candidate?.status || 'N/A' },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/20 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden flex shadow-[#F8F5FF]">
        <div className="w-60 shrink-0 border-r border-b border-[#EEEEEE] p-2 flex flex-col items-center my-5 rounded-br-xl">
          <Avatar name={candidate?.name} />{' '}
          <h2 className="text-sm   text-center">{candidate?.name}</h2>
          <p className="text-[10px] text-slate-500 text-center mt-1 leading-snug">
            {candidate.title}
          </p>
          <p className="text-[10px] text-slate-500 text-center mt-1 leading-snug">
            {candidate.location} · {candidate.experienceYears}
          </p>
          <div className="w-full mt-6 space-y-3 cursor-pointer">
            {candidate?.resumes?.map((r, i) => (
              <div
                key={i}
                onClick={() => {
                  downloadFile(r.url);
                }}
                className="w-full bg-[#F9F6FF] rounded-xl  px-4 py-6 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              >
                <div>
                  <p className="text-sm font-semibold text-slate-700 group-hover:text-violet-600 transition-colors">
                    Resume
                  </p>
                  <p className="text-[10px] text-slate-400 mt-0.5">
                    {formatResumeDate(r.uploadedAt)}
                  </p>{' '}
                </div>
                <span className="text-[8px] font-semibold px-2 py-0.5 rounded-full bg-violet-100 text-violet-600">
                  Download
                </span>{' '}
              </div>
            ))}
          </div>
        </div>
        <div className="flex-1 p-6 overflow-y-auto">
          <div className="space-y-2 my-5">
            <div className="text-sm "> Email:{candidate?.email}</div>
            <div className="text-sm ">Phone: {candidate?.phone}</div>
            <div className="flex gap-1.5 flex-wrap items-center">
              <span> Skills:</span>{' '}
              {candidate?.skills?.slice(0, 7).map((s) => (
                <span
                  key={s}
                  className="text-[10px] px-3 py-1 rounded-full bg-[#F1EDFF] text-[#272727]"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>
          <hr className="mb-5 h-[0.5px] w-full bg-[#D7D7D7] border-0" />{' '}
          <div>
            {details.map((d, i) => (
              <div key={i} className="flex py-3 gap-4">
                <span className="text-xs w-44 shrink-0">{d.label} :</span>
                <span
                  className={`text-sm font-medium ${
                    d.highlight
                      ? 'text-violet-600 underline cursor-pointer'
                      : 'text-slate-800'
                  }`}
                >
                  {d.value}
                </span>
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full  text-slate-500 flex items-center justify-center text-lg transition-colors hover:text-red-500"
        >
          <IoMdClose />
        </button>
      </div>
    </div>
  );
}
